

// 多國語系
export const dataTranslations = (data, locale = "zh-tw") => {
  // console.log("多國語系：", locale, data)
  data = data ?? {}
  if (!data) {
    return ""
  }
  if (locale in data) {
    return data[locale]
  }

  return Object.values(data)[0]
}
// 金額格式
export const currencyFormat = function (value, float = 0) {
  let num = (value / 1).toFixed(float)
  num = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  return num

  // return new Intl.NumberFormat('en', {
  //     minimumFractionDigits:  float
  // }).format(value)
}
// 顯示貨幣符號
export const currencyMap = (currency = "TWD") => {
  if (objCurrency?.[currency]) {
    return objCurrency[currency]
  }
  return {
    name: currency,
    point: 0,
    symbol: currency,
  }
}
export const objCurrency = {
  TWD: {
    name: "新臺幣",
    point: 0,
    symbol: "NT$",
  },
  CNY: {
    name: "人民幣",
    point: 1,
    symbol: "¥",
  },
  USD: {
    name: "美元",
    point: 2,
    symbol: "$",
  },
  MYR: {
    name: "馬幣",
    point: 2,
    symbol: "RM",
  },
}
export function checkValidCurrencyStr(amount, currency = null) {
  const obj = objCurrency
  if (currency) {
    const code = currency.toUpperCase()
    if (code in obj) {
      let num = currencyFormat(amount, obj[code].point)
      return `${obj[code].symbol} ${num}`
    }
  }
  // return currencyFormat(amount)
  return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

// 價格範圍

export const convertPriceCurrencies = (item, currency = 'TWD') => {
  let obj = {
    max_addon_price: 0,
    max_comm_price: 0,
    max_sale_price: 0,
    min_addon_price: 0,
    min_comm_price: 0,
    min_sale_price: 0,
  }
  console.debug("currency", currency)
  console.debug("convertPriceCurrencies", item)
  if (item?.max_addon_price_currencies?.[currency]) {
    obj.max_addon_price = item?.max_addon_price_currencies?.[currency]
  }
  if (item?.max_comm_price_currencies?.[currency]) {
    obj.max_comm_price = item?.max_comm_price_currencies?.[currency]
  }
  if (item?.max_sale_price_currencies?.[currency]) {
    obj.max_sale_price = item?.max_sale_price_currencies?.[currency]
  }
  if (item?.min_addon_price_currencies?.[currency]) {
    obj.min_addon_price = item?.min_addon_price_currencies?.[currency]
  }
  if (item?.min_comm_price_currencies?.[currency]) {
    obj.min_comm_price = item?.min_comm_price_currencies?.[currency]
  }
  if (item?.min_sale_price_currencies?.[currency]) {
    obj['min_sale_price'] = item?.min_sale_price_currencies?.[currency]
  }
  return obj
}

export const priceRange = (data, field, only="", hide_symbol=false) => {
  const symbol = data?.symbol || ""
  let priceMin = null
  let priceMax = null
  let singlePrice = null

  if (field == "sale_price"){
    priceMin = data?.min_sale_price
    priceMax = data?.max_sale_price
  } else if (field == "comm_price") {
    priceMin = data?.min_comm_price
    priceMax = data?.max_comm_price
  } else if (field == "discounted_price") {
    priceMin = data?.min_discounted_price
    priceMax = data?.max_discounted_price
  } else if (field == "owner_coin_reward") {
    priceMin = data?.min_owner_coin_reward
    priceMax = data?.max_owner_coin_reward
  } else if (field == "addon_price") {
    priceMin = data?.min_addon_price
    priceMax = data?.max_addon_price
  }

  // console.debug("data", data)
  // console.debug("priceMin", priceMin)

  if (!priceMin && !priceMax) {
    return ""
  }

  try {
    priceMin = Number(priceMin)
    priceMax = Number(priceMax)
  } catch (err) {
    console.log("priceRange", err)
    return "???"
  }
  only = only.toLowerCase()
  if (only == "min" || priceMin == priceMax) {
    singlePrice = currencyFormat(priceMin, 0, symbol)
  } else if (only == "max") {
    singlePrice = currencyFormat(priceMax, 0, symbol)
  }

  if (singlePrice) {
    if (hide_symbol) {
      return `${singlePrice}`
    }
    return `${symbol} ${singlePrice}`
  }
  if (hide_symbol) {
    return `${currencyFormat(priceMin, 0, symbol)} - ${currencyFormat(priceMax, 0, symbol)}`
  }
  return `${symbol} ${currencyFormat(priceMin, 0, symbol)} - ${currencyFormat(priceMax, 0, symbol)}`
}

// 日期
export const dateFormat = function(str, format="YYYY/MM/DD") {
  // YYYY-MM-DD hh:mm A
  // YYYY-MM-DD HH:mm
  // console.log("zone: ", dayjs.tz.guess())
  if (dayjs(str).isValid()) {
    return dayjs(str).format(format)
    // return dayjs.tz(str, dayjs.tz.guess()).format(format)
  }
  return str
}

// 別名對照
export const lookupAliasTranslations = (obj, lang = "zh-tw") => {
  if (!obj) {
    return null
  }
  if (!obj?.[lang]) {
    obj[lang] = {}
  }
  // console.debug("obj:", obj)
  const list = ['add_to_cart', 'buy_now', 'checkout', 'sale_price', 'comm_price', 'addon_price']
  list.forEach((key) => {
    if (!obj?.[lang]?.[key] || typeof(obj?.[lang]?.[key]) === 'object') {
      obj[lang][key] = null
    }
    // console.debug(key, typeof(obj[lang][key]))
  })
  return obj[lang]
}

//短横线转驼峰
export const dashToHump = function (value) {
  const textArr = value.split("-");
  return textArr.map((item, index) => {
    if (index === 0) return item.toLowerCase();
    return item.slice(0, 1).toUpperCase() + item.slice(1);
  })
    .join("");
}

//驼峰转短横线
export const humpToDash = function (value) {
  return value.replace(/([A-Z])/g, "-$1").toLowerCase()
}
